<template>
  <div class="dtf-add-to-cart">
    <div class="dtf-add-to-cart__submit-wrap">
      <button
        class="dtf-add-to-cart__button"
        type="button"
        :disabled="disableOrderButton"
        @click="submitForm"
      >
        Add To Cart
      </button>
    </div>
    <ArtworkError v-if="spangleSizeEditing" :artwork="spangleErrorObject" />
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import ArtworkError from "./ArtworkError.vue";
import { useDtfStore } from "./store";
import { useSpanglesStore } from "./spangles-module";

export default {
  name: "DtfAddToCart",
  components: {
    ArtworkError
  },
  computed: {
    ...mapState(useDtfStore, [
      "artworks",
      "modalArtworks",
      "isReadyForOrder",
      "currentStore",
      "catalogNumber",
      "isSpangle",
      "removeBgLoading"
    ]),
    ...mapState(useSpanglesStore, [
      "spangleSizeEditing",
      "spanglesLoading",
      "spangleSizeEdited",
      "invalidSpangleSelected",
      "allAPIsCompleted"
    ]),
    disableOrderButton() {
      if (this.backgroundProcessesLoading) {
        return true;
      }

      if (this.isSpangle) {
        return (
          !this.isReadyForOrder ||
          this.spangleSizeEditing ||
          this.spanglesLoading ||
          !this.allAPIsCompleted ||
          !this.spangleSizeEdited ||
          this.invalidSpangleSelected
        );
      }
      return !this.isReadyForOrder;
    },
    spangleErrorObject() {
      return {
        errorMessage: "Please finish editing the size of the artwork before adding it to cart."
      };
    },
    backgroundProcessesLoading() {
      return this.removeBgLoading;
    }
  },
  methods: {
    ...mapActions(useDtfStore, ["submitForm"])
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/mixin.scss";
@import "frontend/init/jiffy/settings.scss";

.dtf-add-to-cart {
  &__submit-wrap {
    margin-bottom: 16px;
  }

  &__button {
    width: 100%;
    height: 52px;
    border-radius: 3px;
    font-weight: 700;
    border: 0;
    background-color: $red-light;
    color: $white;
    font-size: 24px;
    text-transform: uppercase;

    &:focus,
    &:hover {
      background-color: $red;
    }

    &:disabled {
      opacity: 0.4;
      pointer-events: none;
    }
  }
}
</style>
